<template>
  <div>
    <b-navbar
      toggleable="sm"
      type="light"
      variant="light"
    >
      <div class="container">
        <b-navbar-toggle target="nav-text-collapse" />

        <b-navbar-brand>
          <router-link to="/">
            <img
              src="@/assets/images/big_logo.png"
              :alt="$t('scc')"
              style="height: 50px"
            >
          </router-link>
        </b-navbar-brand>

        <b-collapse
          id="nav-text-collapse"
          is-nav
        >
          <b-navbar-nav>
            <b-nav-item href="/">
              <span v-if="token">{{ $t('companyFormPublicView.lvhm') }}</span>
              <span v-else>{{ $t('companyFormPublicView.daxilOl') }}</span>
            </b-nav-item>
            <b-nav-item
              v-if="token && profile==='SUPPLIER'"
              :to="{name: 'vendorManagementOutgoingRequests'}"
            >
              {{ $t('supplierOutgoingVendorRequest.mracitlrim') }}
            </b-nav-item>
          </b-navbar-nav>
        </b-collapse>
      </div>
    </b-navbar>

    <div class="container py-4">
      <div v-if="!form">
        <div class="alert alert-primary">
          {{ $t('companyFormAdminView.mlumatYklnir') }}
        </div>
      </div>
      <div v-else>
        <div class="row mb-3">
          <div class="col-md-8">
            <div class="card mb-0 h-100">
              <div class="card-body">
                <h4>#{{ form.id }}</h4>
                <h3>{{ form.name }}</h3>
                <div class="lead my-2 text-primary">
                  {{
                    $t('companyFormPublicView.getprofilenameformprofiletypeProfiliN', {profileName: getProfileName(form.profileType)})
                  }}
                </div>
                <div
                  class="lead"
                  v-html="formDescription"
                />

                <div
                  v-if=" company && form.company.id === company.id "
                  class="mt-2"
                >
                  <router-link
                    class="btn btn-outline-dark"
                    :to="{name: 'vendorManagementFormManage', params: {id: form.id}}"
                  >
                    {{ $t('companyFormPublicView.formanIdarEt') }}
                  </router-link>

                  <router-link
                    class="btn btn-outline-dark ml-2"
                    :to="{name: 'vendorManagementFormEdit', params: {id: form.id}}"
                  >
                    {{ $t('companyFormPublicView.formanRedaktEt') }}
                  </router-link>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="card">
              <div class="card-body">
                <div class="media align-items-center mt-2">
                  <img
                    class="rounded-circle user-image border mr-2"
                    :src="getPhoto(form.company.logo,'thumbnailCropped')"
                    alt=""
                    style="width: 60px"
                  >
                  <div class="about">
                    <div class="name f-w-600">
                      {{ form.company.name }} {{ getCompanyFormat(form.company.format) }}
                    </div>
                    <div class="status">
                      {{ form.company.taxId }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="card mb-0 ">
              <div class="card-body d-flex  justify-content-between">
                <ShareNetwork
                  network="facebook"
                  :url="formLink"
                  :title="form.name"
                  :description="form.description"
                  class="btn btn-primary m-2 px-2"
                >
                  <i
                    class="fa fa-fw fa-facebook"
                    aria-hidden="true"
                  />
                </ShareNetwork>
                <ShareNetwork
                  network="email"
                  :url="formLink"
                  :title="form.name"
                  :description="form.description"
                  class="btn btn-primary m-2 px-2"
                >
                  <i
                    class="fa fa-fw fa-at"
                    aria-hidden="true"
                  />
                </ShareNetwork>
                <ShareNetwork
                  network="linkedIn"
                  :url="formLink"
                  :title="form.name"
                  class="btn btn-primary  m-2 px-2"
                >
                  <i
                    class="fa fa-fw fa-linkedin"
                    aria-hidden="true"
                  />
                </ShareNetwork>
                <ShareNetwork
                  network="telegram"
                  :url="formLink"
                  :title="form.name"
                  :description="form.description"
                  class="btn btn-info  m-2 px-2"
                >
                  <i
                    class="fa fa-fw fa-telegram"
                    aria-hidden="true"
                  />
                </ShareNetwork>
                <ShareNetwork
                  network="whatsapp"
                  :url="formLink"
                  :title="form.name"
                  :description="form.description"
                  class="btn btn-success  m-2 px-2"
                >
                  <i
                    class="fa fa-fw fa-whatsapp"
                    aria-hidden="true"
                  />
                </ShareNetwork>
              </div>
            </div>
          </div>
        </div>


        <div class="card">
          <div class="card-header">
            <div class="d-flex justify-content-between">
              <div class="lead">
                <div class="lead">
                  {{ $t('companyFormAdminView.sualCavab') }}
                </div>
                <p class="mb-0">
                  {{ $t('companyFormPublicView.sualCavabBlmsindTdarklrinDyrlndirilmsinDairAadaVer') }}
                </p>
              </div>
              <div>
                <button
                  v-if="token && profile ==='SUPPLIER'"
                  v-b-modal.modal-form-ask
                  type="button"
                  class="btn  btn-outline-dark"
                  style="white-space: nowrap"
                >
                  {{ $t('companyFormPublicView.sualVer') }}
                </button>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div v-if="faq.length<1">
              {{ $t('companyFormAdminView.buFormaIlBalSualVerilmyib') }}
            </div>

            <div
              v-for="f in faq"
              :key="f.id"
              class="mb-4"
              style="line-break: anywhere"
            >
              <span class="badge badge-primary">
                {{ f.company.name }} {{ getCompanyFormat(f.company.format) }}
              </span> <br>
              <strong>{{ f.question }}</strong>
              <span v-if="f.status==='NEW' && company && f.company.id === company.id">
                <a
                  href="#"
                  @click.prevent="editQuestion(f)"
                >{{ $t('companyFormPublicView.sualaDzliEt') }}</a>
              </span>

              <div
                v-if="f.status==='NEW'"
                class="text-warning"
              >
                {{ $t('companyFormAdminView.sualCavablanmayb') }}
              </div>
              <div v-else-if="f.status==='ANSWERED'">
                - {{ f.answer }}
              </div>
              <div v-else-if="f.status==='REJECTED'">
                <span class="badge badge-danger">{{ $t('companyFormAdminView.lvEdilib') }}</span> {{ f.answer }}
              </div>
            </div>
          </div>
        </div>


        <div
          v-if="prevRequests.length >0 "
          class="card"
        >
          <div class="card-body">
            <div class="mb-3 lead font-weight-bold">
              {{ $t('companyFormPublicView.irktinizTrfindnDahaVvlByFormaNGndrilmiSorular') }}
            </div>

            <table class="table table-sm table-striped">
              <thead>
                <tr>
                  <th>{{ $t('companyFormPublicView.istifadi') }}</th>
                  <th>{{ $t('companyFormPublicView.hazrlanamTarixi') }}</th>
                  <th>{{ $t('companyFormPublicView.gndrilmTarixi') }}</th>
                  <th>{{ $t('vendorManagementPurchasesReports.status') }}</th>
                  <th>-</th>
                </tr>
              </thead>
              <tr v-for="r in prevRequests">
                <td> {{ r.user.name }} {{ r.user.surname }}</td>
                <td> {{ r.createTime }}</td>
                <td> {{ r.sendTime || '-' }}</td>
                <td>
                  <CompanyFormRequestStatus :status="r.status" />
                </td>
                <td>
                  <router-link
                    class="btn btn-sm btn-outline-primary mx-2"
                    :to="{name: 'vendorManagementOutgoingRequests', query: {form: r.id}}"
                  >
                    {{ $t('supplierOutgoingVendorRequest.trafl') }}
                  </router-link>

                  <router-link
                    v-if="['APPROVED', 'WAITING', 'REJECTED'].indexOf(r.status)<0"
                    class="btn btn-sm btn-outline-primary mx-2"
                    :to="{name: 'vendorFormView', params:{id: r.companyForm.id}, query: {request: r.id}}"
                  >
                    {{ $t('companyFormPublicView.dzliEt') }}
                  </router-link>
                </td>
              </tr>
            </table>
          </div>
        </div>


        <div
          v-if="currentRequest"
          class="card my-4"
        >
          <div class="card-body">
            <div class="row">
              <div class="col-md-9">
                {{ $t('companyFormPublicView.hazrda') }} <strong>{{ currentRequest.user.name }}
                  {{ currentRequest.user.surname }}</strong>
                {{ $t('companyFormPublicView.trfindnTarixindYaradlm', {createTime: currentRequest.createTime}) }}
                <strong>#{{ currentRequest.id }}</strong> {{ $t('companyFormPublicView.nmrliSorunuRedaktEdirsiniz') }}
              </div>
              <div class="col-md-3 text-right">
                <router-link
                  class="btn btn-sm btn-outline-primary"
                  :to="{query:{request: 0}}"
                >
                  {{ $t('companyFormPublicView.yeniFormaDoldur') }}
                </router-link>
              </div>
            </div>
          </div>
        </div>


        <div
          v-if="waitingRequests.length>0"
          class="card my-4"
        >
          <div class="card-body text-danger lead">
            {{ $t('companyFormPublicView.sizArtqBuDyrlndirmFormasNMracitEtmisinizSizinNckiM') }}
          </div>
        </div>
        <div
          v-else
          class="card my-4"
        >
          <div class="card-body">
            <div
              v-if="form.calculable"
              class="card-header"
            >
              Satınalan təşkilat sizin qeyd etdiyiniz cavablara ballar təyin edəcək
            </div>
            <b-tabs
              v-model="activeTabIndex"
              pills
              card
            >
              <b-tab
                v-for="(s,i) in sections"
                :key="s.id"
                :title="s.title"
                :disabled="lastSubmitted<i && activeRequestId <1"
              >
                <template #title>
                  <div class="border border-1 border-primary p-2 rounded">
                    {{ s.title }}
                  </div>
                </template>

                <div class="mb-0">
                  <form @submit.prevent="formSubmitted">
                    <div class="row">
                      <div
                        v-for="(i, j) in sectionInputs[s.id]"
                        :key="i.hash"
                        draggable="true"
                        :class="`col-md-${JSON.parse(i.settings).size}`"
                        class="blockItem mb-3 d-flex justify-content-between"
                        style="flex-direction: column;"
                      >
                        <VendorManagementInputView
                          :key="s.id+'_'+i.id"
                          :ref="'input_' + i.id"
                          :input="i"
                          :is-admin="false"
                          :model-value="values[i.id]"
                          @update:modelValue="dataChanged(i, $event)"
                          @file-upload-status="updateFileUploadStatus"
                          @option-changed="handleOptionChange"
                        />
                      </div>
                    </div>

                    <div class="my-2">
                      <button
                        type="submit"
                        class="btn btn-primary btn-sm"
                      >
                        {{ $t('companyFormPublicView.nvbti') }}
                      </button>
                    </div>
                  </form>
                </div>
              </b-tab>

              <b-tab
                v-if="form.profileType==='SUPPLIER'"
                :key="`sectorSelection`"
                :title="$t('companySearch.faliyytSahlri')"
                :disabled="lastSubmitted<sections.length-1 && activeRequestId <1"
              >
                <template #title>
                  <div class="border border-1 border-danger text-danger p-2 rounded">
                    {{ $t('companySearch.faliyytSahlri') }}
                  </div>
                </template>

                <form @submit.prevent="formSubmitted">
                  <div class="mb-2 font-weight-bold">
                    {{ $t('companyFormPublicView.zFaliyytSektorunuzaUyunSahniSeinSatnalanTkilatHmin') }}
                  </div>


                  <label
                    v-for="s in sectors"
                    class="d-block"
                  >
                    <input
                      v-model="selectedSectors"
                      class="checkbox_animated"
                      type="checkbox"
                      :value="s.id"
                    >
                    {{ s.name }}
                  </label>


                  <div class="py-3">
                    <button
                      type="submit"
                      class="btn btn-success btn-sm"
                    >
                      {{ $t('companyFormPublicView.tamamla') }}
                    </button>
                  </div>
                </form>
              </b-tab>

              <b-tab
                v-if="form.profileType!=='SUPPLIER'"
                :key="`logisticConfirmation`"
                :title="$t('companyFormPublicView.tsdiq')"
                :disabled="lastSubmitted<sections.length && activeRequestId <1"
              >
                <template #title>
                  <div class="border border-1 border-success text-success p-2 rounded">
                    {{ $t('companyFormPublicView.tsdiq') }}
                  </div>
                </template>

                <form @submit.prevent="formSubmitted">
                  <div class="lead">
                    {{ $t('companyFormPublicView.satnalmaTkilatTsdiqldiyiHaldaSizBuIrktinBtnLogisti') }}
                  </div>


                  <div class="py-3">
                    <button
                      type="submit"
                      class="btn btn-success btn-sm"
                    >
                      {{ $t('companyFormPublicView.tamamla') }}
                    </button>
                  </div>
                </form>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>

      <b-modal
        id="modal-form-ask"
        centered
        :title="$t('companyFormPublicView.yeniSual')"
        :hide-footer="true"
        class="theme-modal"
      >
        <form @submit.prevent="askQuestion">
          <div class="mb-3">
            <textarea
              v-model="faqQuestion"
              rows="3"
              class="form-control"
              type="text"
              required
              :placeholder="$t('requestFaq.sualMtniniDaxilEdin')"
            />

            <span class="text-danger small">
              {{ $t('companyFormPublicView.daxilEtdiyinizSualVCavabBtnIstifadilrGstrilck') }}
            </span>
          </div>
          <div class="mb-3">
            <button
              class="btn btn-success mr-2"
              type="submit"
            >
              <span>{{ $t('aucPrices.gndr') }}</span>
            </button>
          </div>
        </form>
      </b-modal>


      <b-modal
        id="modal-form-faq-edit"
        centered
        :title="$t('companyFormPublicView.sualDyi')"
        :hide-footer="true"
        class="theme-modal"
      >
        <form
          v-if="activeFaq"
          @submit.prevent="submitEditQuestion"
        >
          <div class="mb-3">
            <textarea
              v-model="activeFaq.question"
              rows="3"
              class="form-control"
              type="text"
              required
              :placeholder="$t('requestFaq.sualMtniniDaxilEdin')"
            />
          </div>
          <div class="mb-3">
            <button
              class="btn btn-success mr-2"
              type="submit"
            >
              <span>{{ $t('aucPrices.gndr') }}</span>
            </button>
          </div>
        </form>
      </b-modal>
    </div>
  </div>
</template>
<script>
import {mapState} from "vuex";
import {mediaBase} from "@/repositories/Repository";
import {
  askFaqQuestion,
  editFaqQuestion,
  getFormFaq,
  getFormOutgoingRequests,
  getFormRequestById,
  getOfflineForm,
  handleErrors,
  saveFormRequest,
  updateFormRequest
} from "@/repositories/VendorManagementRepository";
import VendorManagementInputView from "@/pages/scc/vendorManagement/builder/VendorManagementInputView.vue";
import {getCompanyFormat, getPhoto, getProfileName} from "@/repositories/Utils";
import CompanyFormRequestStatus from "@/pages/scc/vendorManagement/utils/CompanyFormRequestStatus.vue";

export default {
  components: {CompanyFormRequestStatus, VendorManagementInputView,},
  data() {
    return {
      requiredFileUploads: {}, // Track if an option requires file
      fileUploadStatuses: {}, // Fayl yükləmələrin izlənməsi üçün yeni obyekt
      mediaBase: mediaBase,
      form: null,
      faq: [],
      sections: [],
      inputs: [],
      sectors: [],
      sectionInputs: [],
      values: {},
      formLink: '',
      activeTabIndex: 0,
      prevRequests: [],
      activeRequestId: 0,
      currentRequest: null,
      selectedSectors: [],

      faqQuestion: '',
      activeFaq: null,
      lastSubmitted: 0,

      submitting: false,
    }
  },
  computed: {
    ...mapState({
      token: state => state.auth.token,
      user: state => state.auth.user,
      company: state => state.auth.company,
      profile: state => state.auth.profile,
      hasAdmin: state => state.auth.hasAdmin,
      companyUserStatus: state => state.auth.companyUserStatus,
    }),

    formDescription: function () {
      if (this.form && this.form.description) {
        return this.form.description.replace(/(?:\r\n|\r|\n)/g, '<br>');
      } else {
        return '';
      }
    },
    waitingRequests: function () {
      return this.prevRequests.filter((r) => ['WAITING', 'APPROVED', 'RETURNED', 'EXPIRED'].indexOf(r.status) > -1);
    },
  },
  watch: {
    inputs: {
      deep: true,
      handler() {
        this.calculateSectionInputs();
      }
    },
    sections: {
      deep: true,
      handler() {
        this.calculateSectionInputs();
      }
    },
    "$route"() {
      this.getFormDetails();
    }
  },
  mounted() {
    this.getFormDetails();
  },
  methods: {
    updateFileUploadStatus({id, status}) {
      this.fileUploadStatuses[id] = status; // Fayl yükləmə statusunu izləyir
    },
    handleOptionChange({id, requiresFile,}) {
      this.requiredFileUploads[id] = requiresFile;
    },
    getProfileName(keyword) {
      return getProfileName(keyword, this.i18n);
    },
    getCompanyFormat(keyword) {
      return getCompanyFormat(keyword, this.$i18n.locale);
    },
    getPhoto(path, size) {
      return getPhoto(path, size);
    },
    calculateSectionInputs() {

      let map = {};

      this.sections.forEach((s) => {
        map[s.id] = [];
      })

      this.inputs.forEach((i) => {
        i.hash = JSON.stringify(i);
        map[i.companyFormSectionId].push(i);
      })

      this.sectionInputs = map;
    }
    ,
    getFormDetails() {

      getOfflineForm(this.$route.params.id, this.$i18n.locale, this.company).then(({
                                                                       code,
                                                                       form,
                                                                       sectors,
                                                                       sections,
                                                                       inputs,
                                                                       message,
                                                                       errorCode
                                                                     }) => {
        if (code === 200) {
          this.form = form;
          this.sections = sections;
          this.inputs = inputs;
          this.sectors = sectors;

          this.formLink = window.location.origin + "/form/" + form.id;

          this.loadFaqList();

          this.loadPreviousFormRequests();

        } else if (code === 404) {
          this.$swal({
            title: this.$t("general.notFound"),
            text: this.$t("axtrdgnzFrmTpldm"),
            icon: 'error'
          }).then(() => {
            this.$router.back();
          })
        } else if (code === 403) {
          this.$swal({
            title: "Xəta!",
            text: "Siz bu şirkətin qara siyahısındasınız",
            icon: 'error'
          }).then(() => {
            this.$router.back();
          })
        } else {
          handleErrors(this.$swal, {code, message, errorCode}, null);
        }
      })

    },

    dataChanged(input, value) {
      if (this.token) {
        if (this.profile === this.form.profileType) {

          if (value === '') {
            return; // Prevent resetting if value is unexpectedly empty
          }
          this.values[input.id] = value;

        } else {
          this.$swal({
            title: this.$t("generalModal.warningTitle"),
            icon: 'question',
            text: this.$t("frmnDlrmqZhmtPrflnKcn", {profileType: getProfileName(this.form.profileType)}),
            showCancelButton: true,
            confirmButtonText: this.$t("scmEt"),
            cancelButtonText: this.$t("companyProfile.lvEt2"),
          }).then((result) => {
            if (result.value) {
              this.$router.push({name: 'changeAccount', query: {next: '/form/' + this.form.id}})
            }
          });
        }
      } else {
        this.$swal({
          title: this.$t("generalModal.warningTitle"),
          icon: 'question',
          text: this.$t("frmnDldrmqZhmthsbnz"),
          showCancelButton: true,
          confirmButtonText: this.$t("companyFormPublicView.daxilOl"),
          cancelButtonText: this.$t("companyProfile.lvEt2"),
        }).then((result) => {
          if (result.value) {
            this.$router.push({name: 'Login', query: {next: '/form/' + this.form.id}})
          }
        });
      }
    },

    formSubmitted() {
      // Log the current section and its inputs
      const currentSectionId = this.sections[this.activeTabIndex]?.id;
      const currentInputs = this.sectionInputs[currentSectionId] || [];

      let allValid = true;

      // Loop over each input in the current section and validate if the input is of type 'select'
      currentInputs.forEach((inputItem) => {
        // Get the component reference using the ref name you set: "input_" + input.id
        if (inputItem.inputType === 'select' || inputItem.inputType === 'file' || inputItem.inputType === 'date') {

          let inputComponent = this.$refs['input_' + inputItem.id];

          if (Array.isArray(inputComponent)) {
            inputComponent = inputComponent[0];
          }
          if (inputComponent) {

            const valid = inputComponent.validateField();
            if (!valid) {
              allValid = false;
            }
          }
        }
      });

      if (!allValid) {
        // Prevent moving to the next section and optionally show an error message
        this.$swal({
          title: "Xəta",
          text: "Zəhmət olmasa lazımı xanalı doldurun",
          icon: 'warning'
        });
        return;
      }
      const currentSectionInputs = this.sectionInputs[currentSectionId] || [];
      const incompleteUploads = currentSectionInputs.some((input) => {
        const requiresFile = this.requiredFileUploads[input.id];
        const isUploaded = this.fileUploadStatuses[input.id];
        return requiresFile && !isUploaded;
      });

      if (incompleteUploads) {
        this.$swal({
          title: "Fayl yüklənməsi tələbi",
          text: "Zəhmət olmasa lazımı suallar file yükləyin",
          icon: "warning",
        });
        return;
      }

      if (this.activeTabIndex < this.sections.length) {
        if (this.activeTabIndex === this.lastSubmitted) {
          this.lastSubmitted++;
        }
        setTimeout(() => {
          this.activeTabIndex++;
        }, 100);
      } else {
        if (this.selectedSectors.length < 1 && this.form.profileType === 'SUPPLIER') {
          this.$swal({
            title: this.$t("generalModal.warningTitle"),
            text: this.$t("flyytShsSclmb"),
            icon: 'warning'
          });
          return;
        }

        if (this.submitting) return;
        this.submitting = true;

        // Log values before submission

        if (this.activeRequestId > 0) {
          updateFormRequest(this.token, this.activeRequestId, JSON.stringify(this.values), this.selectedSectors.join(','))
              .then(({code, message, errorCode}) => {
                this.submitting = false;
                if (code === 200) {
                  this.$swal({
                    title: this.$t("generalModal.successTitle"),
                    text: this.$t("srgnzYnldn"),
                    icon: 'success'
                  }).then(() => {
                    this.$router.push({
                      name: 'vendorManagementOutgoingRequests',
                      query: {request: this.activeRequestId}
                    });
                  });
                } else {
                  handleErrors(this.$swal, {code, message, errorCode}, null);
                }
              });
        } else {
          saveFormRequest(this.token, this.form.id, JSON.stringify(this.values), this.selectedSectors.join(','))
              .then(({code, id, message, errorCode}) => {
                this.submitting = false;
                if (code === 200) {
                  this.$swal({
                    title: this.$t("generalModal.successTitle"),
                    text: this.$t("srgnzYddSxlnld"),
                    icon: 'success'
                  }).then(() => {
                    this.$router.push({name: 'vendorManagementOutgoingRequests', query: {request: id}});
                  });
                } else {
                  handleErrors(this.$swal, {code, message, errorCode}, null);
                }
              });
        }
      }
    },
    loadPreviousFormRequests() {

      this.prevRequests = [];
      this.values = {};
      this.currentRequest = null;

      this.inputs.forEach(v => {
        this.values[v.id] = '';
      });

      if (this.token) {
        this.activeRequestId = this.$route.query['request'] || 0;

        if (this.activeRequestId < 1) {

          getFormOutgoingRequests(this.token, this.form.id).then(requests => {
            this.prevRequests = requests;
          });
        } else {

          getFormRequestById(this.token, this.activeRequestId).then(({code, form, message, errorCode}) => {
            if (code === 200) {

              if (form.companyForm.id !== this.form.id) {
                this.$router.push({name: 'vendorFormView', params: {id: this.form.id}})
              } else if (form.status === 'APPROVED') {

                this.$swal({
                  title: this.$t("generalModal.warningTitle"),
                  text: this.$t("mrctnzStlnlnTshklt"),
                  icon: 'warning'
                }).then(() => {
                  this.$router.push({name: 'vendorFormView', params: {id: this.form.id}})
                })

              } else if (form.status === 'REJECTED') {

                this.$swal({
                  title: this.$t("generalModal.warningTitle"),
                  text: this.$t("mrctnzStnlnTshkltTrfndn`"),
                  icon: 'warning'
                }).then(() => {
                  this.$router.push({name: 'vendorFormView', params: {id: this.form.id}})
                })

              } else {
                this.values = JSON.parse(form.response);
                this.currentRequest = form;
                this.selectedSectors = form.sectors.split(',');
              }

            } else if (code === 404) {
              this.$swal({
                title: this.$t("general.notFound"),
                text: this.$t("axtrdgnzFrmTpldm"),
                icon: 'error'
              }).then(() => {
                this.$router.back();
              })
            } else {
              handleErrors(this.$swal, {code, message, errorCode}, null);
            }
          })

        }

      } else {

        this.$swal({
          title: this.$t("generalModal.warningTitle"),
          icon: 'question',
          text: this.$t("frmnDldrmqZhmthsbnz"),
          showCancelButton: true,
          confirmButtonText: this.$t("companyFormPublicView.daxilOl"),
          cancelButtonText: this.$t("companyProfile.lvEt2"),
        }).then((result) => {
          if (result.value) {
            this.$router.push({
              name: 'Login',
              query: {next: '/form/' + this.form.id + "?request=" + this.activeRequestId}
            })
          }
        });
      }
    },

    loadFaqList() {
      getFormFaq(this.token, this.form.id).then(list => {
        this.faq = list;
      })
    },

    askQuestion() {


      askFaqQuestion(this.token, this.form.id, this.faqQuestion).then(data => {
        if (data.code === 200) {
          this.loadFaqList();
          this.faqQuestion = '';
          this.$bvModal.hide('modal-form-ask');
        } else {
          handleErrors(this.$swal, data, null);
        }
      });

    },

    editQuestion(faq) {
      this.activeFaq = {...faq};
      this.$bvModal.show('modal-form-faq-edit');
    },
    submitEditQuestion() {
      editFaqQuestion(this.token, this.activeFaq.id, this.activeFaq.question).then(data => {
        if (data.code === 200) {
          this.loadFaqList();
          this.$bvModal.hide('modal-form-faq-edit');
        } else {
          handleErrors(this.$swal, data, null);
        }
      });
    }
  }
}
</script>
<style scoped lang="scss">

.addNewBlockButton {
  padding: 20px;
  border: 1px dotted #474e50;
  background: #e9ecec;
  text-align: center;
  border-radius: 15px;
  cursor: pointer;

  &:hover {
    background: #a6afaf;
  }
}
</style>
